export const propertiesSettings = {
    fremiumPlanMaxYield: 5, // in percent
    maxConcurrentFrozenByUser: 2,
};
